import {
	DesktopOnboardingBackground,
	MobileOnboardingBackground,
	SociosLogo,
	useIntl,
	useSettings
} from '@capsicum/common';
import { Button, Image, useWindowSize } from '@capsicum/common-web';
import { getOnboardingMessages } from '@capsicum/features/onboard/shared';
import { type FC, useCallback, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { match } from 'ts-pattern';

import * as Components from '../components.styled';

import { SportIcons } from './SportIcons';

export const FirstPage: FC<{ goToLogin: () => void; next: () => void }> = ({ goToLogin, next }) => {
	const { colors, spacings } = useTheme();
	const { size } = useWindowSize();
	const [imageLoaded, setImageLoaded] = useState(false);
	const {
		settings: { isPoblanoEnabled }
	} = useSettings();

	const { $t } = useIntl();

	const handleImageLoad = useCallback(() => {
		setImageLoaded(true);
	}, []);

	return (
		<Components.Wrapper>
			<S.Background
				alt="background"
				draggable={false}
				src={match(size)
					.with('mobile', () => MobileOnboardingBackground)
					.otherwise(() => DesktopOnboardingBackground)}
				onLoad={handleImageLoad}
			/>
			<S.ContentContainer $imageLoaded={imageLoaded}>
				{isPoblanoEnabled && (
					<S.ImageContainer>
						<Image alt="Socios.com" src={SociosLogo} width={206} />
					</S.ImageContainer>
				)}
				<Components.HeadlineText>
					{$t(getOnboardingMessages('onboardingHeadlineScreen0').id)}
				</Components.HeadlineText>
				{!isPoblanoEnabled && <S.StyledSportsIcons color={colors.icons.onDark.enabled} />}
				<S.CTAWrapper>
					<Button
						buttonElementStyle={{ padding: `0 ${spacings.small}` }}
						color="light"
						testID="onboarding-login-button"
						text={$t('onboarding.buttons.logIn')}
						variant="outlined"
						onClick={goToLogin}
					/>
					<Button
						buttonElementStyle={{ padding: `0 ${spacings.xxsmall}` }}
						testID="onboarding-getStarted-button"
						text={$t('onboarding.buttons.getStarted')}
						variant="default"
						onClick={next}
					/>
				</S.CTAWrapper>
			</S.ContentContainer>
		</Components.Wrapper>
	);
};

namespace S {
	export const ContentContainer = styled.div<{ $imageLoaded: boolean }>`
		opacity: ${({ $imageLoaded }) => ($imageLoaded ? 1 : 0)};
		pointer-events: ${({ $imageLoaded }) => ($imageLoaded ? 'auto' : 'none')};
	`;
	export const CTAWrapper = styled.div`
		display: grid;
		grid-template-columns: 1fr 1fr;
		margin-top: ${({ theme }) => theme.spacings.medium};
		padding: ${({ theme }) => theme.spacings.medium};
		padding-bottom: ${({ theme }) => theme.spacings.xlarge};
		gap: ${({ theme }) => theme.spacings.medium};
		width: 100%;
	`;

	export const StyledSportsIcons = styled(SportIcons)`
		margin-top: ${({ theme }) => theme.spacings.medium};
	`;

	export const Background = styled(Image)`
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: -1;
		object-fit: cover;
	`;

	export const ImageContainer = styled.div`
		display: flex;
		justify-content: center;
	`;
}
